import axios from 'axios'
import { DATAMASTER_ENDPOINT } from 'common/endpoints'
import { processDefaultAndTotals } from 'common/formulario/processDefaultAndTotals'

const getCategorySchema = async (category) => {
    const results = await axios.get(`${DATAMASTER_ENDPOINT}/categorySchema/?category=${category}`)
    const _advancedInfoSchema = { ...results.data.summary }
    const tipo_cotizador = _advancedInfoSchema.tipo_cotizador ? { ..._advancedInfoSchema.tipo_cotizador } : null
    const segmento_cotizador = _advancedInfoSchema.segmento_cotizador ? { ..._advancedInfoSchema.segmento_cotizador } : null
    const _basicInfoSchema = {
        infoVehiculo: {
            ...(tipo_cotizador && { tipo_cotizador }),
            ...(segmento_cotizador && { segmento_cotizador })
        }
    }
    delete _advancedInfoSchema.tipo_cotizador
    delete _advancedInfoSchema.segmento_cotizador

    const {
        countTotalFields: _advancedInfoTotalFields
    } = processDefaultAndTotals(_advancedInfoSchema)

    return {
        _advancedInfoSchema,
        _basicInfoSchema,
        _advancedInfoTotalFields
    }
}

export default getCategorySchema